import type {LocalizationContextType} from 'localization/context/types';
import type {FieldRootKeys} from '../../../schemaDefinition/functions/types';
import {getFieldString} from './getFieldString';

export const getPlaceholder = (
  fieldRootKeys: FieldRootKeys | undefined,
  localization: LocalizationContextType,
): string | undefined =>
  getFieldString(fieldRootKeys, false, '.placeholder', localization);
